
import { shellStringResources } from '../../Resources/ShellStringResources';
import { GlobalVariables } from '../../constants/globals';
import { format, sanitizeAndFormatString } from '../../shared/utils/string.util';
import { IModel, IAttribute, IViolation } from '../base/annotation';
import { Copier } from '../base/copier';
import { Metamodel } from '../base/model';
import { LinkedService } from '../linkedservice/linkedservice';
import { ModelConstants } from '../model-constants';
import { SSISActivity } from './ssis.base.activity';

@Metamodel.model({
    name: ModelConstants.executeSSISPackageActivity,
    display: [
        format(shellStringResources.ModelName_ActivityTemplate, shellStringResources.FabricSsisActivityLabel),
        format(shellStringResources.ModelName_ActivitiesTemplate, shellStringResources.FabricSsisActivityLabel)
    ],
    referable: true,
    disabled: !GlobalVariables.isTrident
})
export class InvokeSSISPackageActivity extends SSISActivity {
    public static readonly MODEL: IModel;
    public static readonly LINKEDSERVICE: IAttribute;
    public static readonly LOG_LINKEDSERVICE: IAttribute;

    public static readonly PACKAGE_PATH: IAttribute;
    public static readonly ENABLE_LOGGING: IAttribute;
    public static readonly LOG_OUTPUT_TABLE_PREFIX: IAttribute;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }

    @Metamodel.attribute({
        display: shellStringResources.ConnectionLabel,
        association: 'LINKEDSERVICE',
        templatable: false,
        reference: true,
        type: LinkedService.MODEL,
        constraint: {
            required: true
        }
    })
    public linkedService: LinkedService;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_LinkedService,
        association: 'LOG_LINKEDSERVICE',
        templatable: false,
        reference: true,
        type: LinkedService.MODEL
    })
    public logLinkedService: LinkedService;

    public override packageLocation: 'File' = 'File';

    @Metamodel.attribute({
        display: shellStringResources.SsisActivityPackagePathLabel,
        association: 'PACKAGE_PATH',
        templatable: true,
        constraint: {
            validator: InvokeSSISPackageActivity.createPackagePathValidator()
        }
    })
    public packagePath: string;

    @Metamodel.attribute({
        display: shellStringResources.DeleteLoggingSetting_EnableLabel,
        association: 'ENABLE_LOGGING',
        templatable: true
    })
    public enableLogging: boolean = false;

    public logOutputType: 'Table' | 'File' | 'FileAndTable' = 'File';

    @Metamodel.attribute({
        display: shellStringResources.Table_name_Label,
        association: 'LOG_OUTPUT_TABLE_PREFIX',
        templatable: true
    })
    public logOutputTablePrefix: string;

    @Metamodel.attribute({
        reference: true,
        type: LinkedService.MODEL
    })
    public artifactDmtsCredentialForSsisStore?: LinkedService;

    private static createPackagePathValidator(): (activity?: InvokeSSISPackageActivity, packagePath?: string, violation?: IViolation) => IViolation[] | undefined {
        return (activity?: InvokeSSISPackageActivity, packagePath?: string, violation?: IViolation): IViolation[] | undefined => {
            if (!activity || activity.fileType === InvokeSSISPackageActivity.PACKAGE_LOCATION_PROJECT_FILE) {
                return undefined;
            }
            return !packagePath ? [{
                context: activity,
                message: () => sanitizeAndFormatString(shellStringResources.RequiredValidatorMessage, shellStringResources.SsisActivityLabel, '\'' + activity.name + '\'',
                    shellStringResources.SsisActivityPackagePathLabel),
                attributes: [InvokeSSISPackageActivity.PACKAGE_PATH]
            }] : undefined;
        };
    }

    public onActivityCloned(clonedActivity: InvokeSSISPackageActivity, context: { inlineDataset?: boolean }): void {
        if (GlobalVariables.isTrident) {
            if (this.artifactDmtsCredentialForSsisStore?.parameterized || this.linkedService?.parameterized) {
                if (this.artifactDmtsCredentialForSsisStore != null) {
                    clonedActivity.artifactDmtsCredentialForSsisStore = Copier.clone(
                        context,
                        [this.artifactDmtsCredentialForSsisStore],
                        undefined,
                        true
                    )[0] as LinkedService;
                }
                if (this.linkedService != null) {
                    clonedActivity.linkedService = Copier.clone(
                        context,
                        [this.linkedService],
                        undefined,
                        true
                    )[0] as LinkedService;
                }
            }
        }
    }
}